import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function Footer() {
  const { t } = useTranslation()

  return (
    <footer className="bg-slate-900 text-slate-300 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="space-y-6">
            <div className="flex flex-col items-start">
              <span className="text-white font-bold text-2xl tracking-tighter leading-none">
                NDT
              </span>
              <span className="text-[10px] uppercase tracking-widest font-bold text-slate-500">
                NiceDay Technologies
              </span>
            </div>
            <p className="text-sm leading-relaxed">{t('footer.description')}</p>
            <div className="flex gap-4">
              <a
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-primary transition-colors"
                href="#"
                aria-label="LinkedIn"
              >
                <span className="material-icons">linkedin</span>
              </a>
              <a
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-primary transition-colors"
                href="#"
                aria-label="Twitter"
              >
                <span className="material-icons">twitter</span>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold mb-6">{t('footer.solutions')}</h4>
            <ul className="space-y-4 text-sm">
              <li>
                <Link to="/solutions" className="hover:text-primary transition-colors">
                  {t('solutions.security.category')}
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="hover:text-primary transition-colors">
                  {t('solutions.experience.category')}
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="hover:text-primary transition-colors">
                  {t('solutions.payment.category')}
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="hover:text-primary transition-colors">
                  {t('solutions.software.category')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-6">{t('footer.company')}</h4>
            <ul className="space-y-4 text-sm">
              <li>
                <Link to="/a-propos" className="hover:text-primary transition-colors">
                  {t('footer.about')}
                </Link>
              </li>
              <li>
                <a href="#" className="hover:text-primary transition-colors">
                  {t('footer.commitments')}
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-primary transition-colors">
                  {t('footer.recruitment')}
                </a>
              </li>
              <li>
                <Link to="/contact" className="hover:text-primary transition-colors">
                  {t('footer.contact')}
                </Link>
              </li>
              <li>
                <Link to="/support" className="hover:text-primary transition-colors">
                  {t('nav.support')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-6">{t('footer.contact')}</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <span className="material-icons text-primary">phone</span>
                <span>+33 (0)1 23 45 67 89</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="material-icons text-primary">email</span>
                <span>contact@niceday.tech</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="material-icons text-primary">place</span>
                <span>Paris, France</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-medium">
          <p>{t('footer.copyright')}</p>
          <div className="flex flex-wrap justify-center md:justify-end gap-4 md:gap-6">
            <Link to="/mentions-legales" className="hover:text-white">
              {t('footer.legal')}
            </Link>
            <Link to="/rgpd" className="hover:text-white">
              {t('footer.rgpd')}
            </Link>
            <Link to="/cookies" className="hover:text-white">
              {t('footer.cookies')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
